var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-list"},_vm._l((_vm.posts),function(post){return _c('div',{key:post.id},[_c('post',{attrs:{"post":post}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }